import { useMutation } from 'react-query'
import { ICreateSubscription, ISubscriptionStatus } from '../generated-types/notification'
import { queryClient } from '../query-client'
import { useGet } from './reactQuery'
import { requestProvider } from './requestProvider'

const baseUrl = (customerId: EntityId) => `customers/${customerId}/subscriptions`

export const subscriptionEndpoints = {
  status: (customerId: EntityId, entityType: string, entityId: EntityId) =>
    `${baseUrl(customerId)}/status?entityType=${entityType}&entityId=${entityId}`,
  follow: (customerId: EntityId) => `${baseUrl(customerId)}`,
  unfollow: (customerId: EntityId, entityType: string, entityId: EntityId) =>
    `${baseUrl(customerId)}?entityType=${entityType}&entityId=${entityId}`,
}

export const useGetSubscriptionStatus = (customerId: EntityId, entityType: string, entityId: EntityId) =>
  useGet<ISubscriptionStatus>(subscriptionEndpoints.status(customerId, entityType, entityId), undefined, {
    enabled: !!customerId && !!entityType && !!entityId,
  })

const invalidateStatus = (customerId: EntityId, entityType: string, entityId: EntityId) =>
  queryClient.invalidateQueries([subscriptionEndpoints.status(customerId, entityType, entityId)])

export const useFollowEntity = (customerId: EntityId) =>
  useMutation((body: ICreateSubscription) => requestProvider.post(subscriptionEndpoints.follow(customerId), body), {
    onSuccess: (_data, body) => invalidateStatus(customerId, body.entityType, body.entityId),
  })

export const useUnfollowEntity = (customerId: EntityId) =>
  useMutation(
    ({ entityType, entityId }: { entityType: string; entityId: EntityId }) =>
      requestProvider.delete(subscriptionEndpoints.unfollow(customerId, entityType, entityId)),
    {
      onSuccess: (_data, { entityType, entityId }) => invalidateStatus(customerId, entityType, entityId),
    },
  )
